<template>
  <div class="loginmodal">
    <div class="modal-content">
      <span class="login-kicker">MEMBERS ONLY</span>
      <h1 class="login-popup-title"><span class="ivory-wordmark">MEGA</span></h1>
      <h2>MEGA LOGIN</h2>
      <p class="login-popup-copy">프라이빗 카지노의 특별한 순간을 시작하세요.</p>
      <ui-input :className="'logininput'" :type="'text'" :placeholder="$t('front.common.memId')" @input="getMemId" @enter="onSubmit"/>
      <ui-input :className="'logininput'" :type="'password'" :placeholder="$t('front.common.password')" @input="getMemPass" @enter="onSubmit"/>

      <section class="captcha-box">
        <VueClientRecaptcha
            :value="inputValue"
            :count="4"
            chars="12345"
            :hideLines="true"
            custom-text-color="black"
            @getCode="getCaptchaCode"
            @isValid="checkValidCaptcha"
        >
          <template>
            <span style="color: blue">with Custom Text Or Icon</span>
          </template>
        </VueClientRecaptcha>
        <input
            v-model="inputValue"
            :placeholder="$t('front.login.placeholder')"
            class="input"
            type="text"
            @keyup.enter="onSubmit"
        />
      </section>
      <!--a class="finds">{{$t('front.common.memId')}}/{{$t('front.common.password')}} {{$t('front.common.find')}}</a-->
      <ui-button :className="'loginnbtn on'" :text="$t('front.login.loginButton')"  @click.prevent="onSubmit" />
      <p class="jointxt">
        <ui-button :className="'joinnbtn'" :text="$t('front.common.signup')" @click="$emit('close', 'join')"/>
      </p>
      <div class="loginclose" @click="$emit('close')"><img src="@/assets/img/icon_cancel.png" /></div>
    </div>
  </div>
</template>

<script>

import UiButton from '@/components/ui/UiButton'
import UiInput from '@/components/ui/UiInput'

import { signIn } from '@/api/member'
import { setAuthData } from '@/libs/auth-helper'
import store from '@/store'

import VueClientRecaptcha from 'vue-client-recaptcha'

export default {
  name: 'Signin',
  components: {
    UiButton,
    UiInput,
    VueClientRecaptcha
  },
  computed: {
    canSubmit () {
      return this.model.memId && this.model.memPass
    }
  },
  data () {
    return {
      model: {
        memId: '',
        memPass: ''
      },
      data: {
        captchaCode: null,
        isValid: false
      },
      inputValue: null
    }
  },
  methods: {
    getCaptchaCode (value) {
      this.data.captchaCode = value
    },
    checkValidCaptcha (value) {
      this.data.isValid = value
    },
    getMemId (value) {
      this.model.memId = value
    },
    getMemPass (value) {
      this.model.memPass = value
    },
    setReloadCaptcha () {
      setTimeout(() => {
        if (document.querySelector('.vue_client_recaptcha_icon')) {
          document.querySelector('.vue_client_recaptcha_icon').click()
        }
      }, 500)
    },
    async onSubmit () {
      let reloadCaptcha = false
      if (!this.data.isValid) {
        reloadCaptcha = true
        await this.onAlert('warningart', '자동 입력 방지 코드를 확인해주세요.')
      }

      if (this.model.memId === '') {
        reloadCaptcha = true
        this.onAlert('warningart', 'front.signin.emptyMemId')
      }
      if (this.model.memPass === '') {
        reloadCaptcha = true
        this.onAlert('warningart', 'front.signin.emptyMemPass')
      }

      if (!this.canSubmit) {
        reloadCaptcha = true
      }

      if (reloadCaptcha) {
        this.setReloadCaptcha()
        return false
      }

      /*
      * api/member.js 참고
      */
      signIn(this.model).then(async response => {
        const result = response.data
        const data = result.data

        if (result.resultCode === '0') {
          setAuthData(data)
          store.commit('setUserData', data.member)
          store.dispatch('storeCommonCode').then(commonCode => {
            if (data.msgInfo) {
              store.dispatch('storeUserUnReadMessageCount', data.msgInfo.newMsg)
            }
            this.$emit('close', 'signin')
          })

          // setTimeout(function () {
          //   this.$emit('close', 'signin')
          // }.bind(this), 100)
        } else if (result.resultCode === 'U001' || result.resultCode === 'LX02') {
          await this.onCheck('err.' + result.resultCode)
          this.setReloadCaptcha()
        } else {
          // const confirm = await this.onConfirm('api.' + result.resultCode)
          // if (confirm) {
          //   this.$emit('signup')
          // }
          await this.onCheck('로그인정보가 올바르지 않습니다. 확인해주세요.')
          this.setReloadCaptcha()
        }
      }).catch(err => {
        console.error('login err : ', err.message)

        if (err.message === 'no member') {
          // alert('로그인정보가 올바르지 않습니다. 확인해주세요.')
          this.onCheck('로그인정보가 올바르지 않습니다. 확인해주세요.')
        } else {
          alert(err.message)
        }
      })
    }
  }
}
</script>

<style scoped>
.captcha-box { margin-top: 15px; }
.captcha-box .vue_client_recaptcha {
  background-color: #fff;
  width: 50%;
  display: inline-block;
  border-radius: 3px;
  border: 1px solid #60452a;
  box-sizing: border-box;
  box-shadow: 0 0 6px 0 rgb(0 0 0 / 16%);
}

/deep/ .captcha-box .vue_client_recaptcha .vue_client_recaptcha_icon {
  float: right;
  display: inline-block;
}

.captcha-box .input {
  position: relative;
  width: calc(50% - 30px);
  height: 54px;
  text-align: center;
  font-size: 16px;
  letter-spacing: -0.025em;
  border-radius: 3px;
  box-shadow: 0 0 6px 0 rgb(0 0 0 / 16%);
  border: solid 1px #222;
  background-color: #333;
  color: #fff;
  vertical-align: top;
  margin-left: 10px;
}
</style>

<style scoped src="@/styles/header.css"></style>
<style scoped src="@/styles/common.css"></style>
<style scoped src="@/styles/subcommon.css"></style>
<style scoped>
.loginmodal{display:flex!important;align-items:center!important;justify-content:center!important;padding:28px;box-sizing:border-box;background:rgba(0,0,0,.9)!important;backdrop-filter:blur(9px)}.modal-content{position:relative;box-sizing:border-box;width:430px;max-width:calc(100vw - 40px);margin:0!important;padding:42px 42px 38px!important;border:1px solid #4f2029!important;border-radius:0!important;background:linear-gradient(145deg,#1d0a0e,#09090b 70%)!important;box-shadow:0 32px 100px rgba(0,0,0,.82),inset 0 1px rgba(255,255,255,.04)!important}.modal-content:before{content:"";position:absolute;left:36px;right:36px;top:0;height:2px;background:linear-gradient(90deg,transparent,#c11d3a,transparent)}.login-kicker{display:block;margin-bottom:16px;text-align:center;color:#c82542;font-size:9px;font-weight:800;letter-spacing:.31em}.login-popup-title{margin:0;text-align:center}.login-popup-title img{display:block;width:178px;height:auto;margin:0 auto;filter:grayscale(1) brightness(2.05) contrast(.88)}.modal-content h2{display:block!important;margin:22px 0 0!important;text-align:center;color:#f2f2f3!important;font-family:Georgia,'Times New Roman',serif;font-size:25px!important;font-weight:700;letter-spacing:.08em}.modal-content h2:after{display:none!important;content:none!important}.login-popup-copy{margin:8px 0 24px;text-align:center;color:#85858c;font-size:11px}.modal-content .logininput{box-sizing:border-box;width:100%;height:50px;margin:0 0 10px;padding:0 15px;border:1px solid #343438!important;border-radius:0!important;background:#0b0b0d!important;color:#f0f0f2!important;box-shadow:none!important}.modal-content .logininput::placeholder{color:#6f6f75}.modal-content .logininput:focus{border-color:#a91933!important;box-shadow:0 0 0 3px rgba(169,25,51,.13)!important;outline:0}.captcha-box{display:flex;height:50px;margin:0 0 18px!important;border:1px solid #343438;background:#0b0b0d;overflow:hidden}.captcha-box .vue_client_recaptcha{width:145px!important;border:0!important;border-right:1px solid #343438!important;border-radius:0!important;background:#d8d8db!important;box-shadow:none!important}.captcha-box .input{box-sizing:border-box;min-width:0;flex:1;width:auto!important;height:48px!important;margin:0!important;padding:0 10px;border:0!important;border-radius:0!important;background:#0b0b0d!important;color:#eee!important;font-size:13px!important;box-shadow:none!important}.modal-content .loginnbtn{display:flex;align-items:center;justify-content:center;width:100%;height:48px;margin:0!important;border:1px solid #d12845!important;border-radius:0!important;background:linear-gradient(135deg,#b41834,#781020)!important;color:#fff!important;font-size:12px!important;font-weight:700;letter-spacing:.08em;text-shadow:none!important;box-shadow:0 10px 25px rgba(139,14,36,.24)!important}.modal-content .loginnbtn:hover{background:linear-gradient(135deg,#cf2947,#91142a)!important}.jointxt{margin:10px 0 0!important}.modal-content .joinnbtn{display:flex;align-items:center;justify-content:center;width:100%;height:46px;margin:0!important;border:1px solid #404045!important;border-radius:0!important;background:#121214!important;color:#c6c6ca!important;font-size:12px!important;font-weight:700;letter-spacing:.05em;text-shadow:none!important}.modal-content .joinnbtn:hover{border-color:#66666c!important;background:#18181b!important}.loginclose{position:absolute!important;right:12px!important;top:12px!important;display:flex!important;align-items:center;justify-content:center;width:32px!important;height:32px!important;border:1px solid transparent;background:transparent!important;opacity:.8}.loginclose:hover{border-color:#3c3c40;background:#151517!important;opacity:1}.loginclose img{width:13px!important;height:13px!important;filter:grayscale(1) brightness(2)}
@media(max-width:520px){.loginmodal{padding:16px}.modal-content{max-width:calc(100vw - 32px);padding:36px 24px 28px!important}.login-popup-title img{width:155px}.modal-content h2{font-size:22px!important}.captcha-box .vue_client_recaptcha{width:125px!important}}
</style>
